import { render } from "./PageTransitionEnd.vue?vue&type=template&id=334f54eb&ts=true"
import script from "./PageTransitionEnd.vue?vue&type=script&lang=ts"
export * from "./PageTransitionEnd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__